import React from 'react'

import Lottie from 'lottie-react'
import { useQuery } from 'react-query'

import { replaceWithCDNUrl } from '@cash-web/shared-util-url'

export interface AnimationProps {
  /** URL to fetch the Lottie JSON animation from */
  animationUrl?: string
  /** Width of the animation container */
  width?: number | string
  /** Optional alt text for accessibility */
  alt?: string
}

async function fetchAnimationData(url: string | undefined): Promise<Response | null> {
  if (!url) return null
  const fetchUrl = replaceWithCDNUrl(url) || url
  const response = await fetch(fetchUrl, {
    mode: 'cors',
    credentials: 'omit',
  })

  if (!response.ok) {
    return null
  }

  return response.json()
}

export function Animation({ animationUrl, width, alt }: AnimationProps): React.ReactElement | null {
  const { data: animationJson } = useQuery(['animation', animationUrl], () => fetchAnimationData(animationUrl), {
    enabled: !!animationUrl,
    retry: false,
    refetchOnWindowFocus: false,
  })

  if (!animationJson) {
    return null
  }

  return (
    <Lottie
      data-testid="lottie-animation"
      role="img"
      aria-label={alt}
      style={{ width }}
      animationData={animationJson}
      loop={false}
      autoplay={true}
    />
  )
}
